// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/manage_order",
    element: lazy(() => import("../pages/Order/")),
  },
  {
    path: "/order_variant/:orderId",
    element: lazy(() => import("../pages/Order/OrderVariants")),
  },
  {
    path: "/order_listing",
    element: lazy(() => import("../pages/Order/OrderListing")),
  },
];

export default routes;
